export default __webpack_public_path__ + "static/media/websiteBr.a3a55e97.png";